import { healingPicks } from "@/mocks/comics";

export default function HealingList() {
  return (
    <section id="healing" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-bold uppercase tracking-widest text-accent-600">
            治愈系漫画清单
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            心情需要充电时，就看这几部
          </h2>
          <p className="mt-3 text-foreground-700">
            我们每周从治愈向作品里挑出值得一读的软萌佳作，画风与剧情兼备，
            陪你度过需要温柔以待的时刻。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {healingPicks.map((pick) => (
            <article
              key={pick.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200"
            >
              <div className="relative aspect-[10/7] overflow-hidden">
                <img
                  src={pick.image}
                  alt={`${pick.title}治愈系漫画清单推荐`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-bold text-accent-700 backdrop-blur">
                  {pick.tagline}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-xl text-foreground-950">
                  {pick.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {pick.reason}
                </p>
                <a
                  href="#faq"
                  className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700"
                >
                  加入收藏清单
                  <i className="ri-heart-add-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}